import React from 'react';
import './TabNavigation.css';

const TabNavigation = ({ 
  activeTab, 
  onTabChange, 
  tabs = [],
  className = '',
  disabled = false 
}) => {
  const handleTabClick = (tabId) => {
    if (disabled) return;
    onTabChange(tabId);
  };

  return (
    <div className={`tab-navigation ${className}`}>
      <div className="tab-navigation-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeTab === tab.id ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => handleTabClick(tab.id)}
            disabled={disabled}
            title={tab.description}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
            {tab.badge && (
              <span className="tab-badge">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>
      
      {/* Индикатор активного таба */}
      <div className="tab-indicator" />
    </div>
  );
};

export default TabNavigation;
